import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { IonContent } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MatBottomSheet, MatBottomSheetConfig, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { SearchService } from '../core/services/search.service';
import { LoadingController } from '@ionic/angular';
import { MarketplaceFilterComponent } from './marketplace-filter/marketplace-filter.component';

@Component({
  selector: 'app-marketplace',
  templateUrl: './marketplace.page.html',
  styleUrls: ['./marketplace.page.scss']
})
export class MarketplacePage implements OnInit, OnDestroy {

  breadcrumbList = [
    {
      label: 'Dashboard',
      url: '/baseapp/dashboard',
    },
    {
      label: 'Marketplace',
      url: '/baseapp/marketplace',
    },
  ];

  @ViewChild(IonContent) content: IonContent;

  loader: HTMLIonLoadingElement;
  searchSubscription: Subscription;
  categorySubscription: Subscription;
  routerEventsSubscription: Subscription;

  brandShow   = false;
  productShow = false;
  objectShow  = false;
  filterShow  = false;
  versionShow = false;

  sortCatalog: any = [
    {
      id: 1,
      label: 'Newest Arrivals'
    },
    {
      id: 2,
      label: 'Latest Updates'
    }
  ];
  
  catalogData: any = [];
  catalogDataLoaded: boolean = false;
  catalogFilterData: any = [];
  allFilterData: any;
  filterData: any;
  filterArray: any = [];
  filterCount: number = 4;
  cartData: any;
  categoryArray: any = [];
  categoryList: any = [];
  defaultCategory: any;
  currentCategory: any = 'All Categories';
  brandArray: any = [];
  brandList: any = [];
  productNameArray: any = [];
  productNameList: any = [];
  productNameCount: any;
  initialProductNameCount = 10;
  versionArray: any = [];
  versionList: any = [];
  versionCount: any;
  initialVersionCount = 10;
  businessObjArray: any = [];
  businessObjList: any = [];
  businessObjCount: any;
  initialBusinessObjCount = 10;
  methodArray: any = [];
  methodList: any = [];
  typeArray: any = [];
  typeList: any = [];
  priceArray: any = [];
  priceList: any = [];
  
  page_min = 0;
  page_max = 10;
  total_records = 0;
  sortBy: any = this.sortCatalog[0]['id'];
  searchInput = '';
 
  currentPage: any = 1;
  totalPages: any;
  minRecords: any = 1;
  maxRecords: any = 10;
  
  
  bottomSheetRef = {} as MatBottomSheetRef<MarketplaceFilterComponent>;
  sortSelection: any = this.sortCatalog[0]['label'];
 
  constructor(
    private backendService: BackendService,
    public storage: Storage,
    public helperService: HelperService,
    public searchService: SearchService,
    private router: Router,
    private _bottomSheet: MatBottomSheet,
    private loadingController: LoadingController
  ) {}

  async ngOnInit(): Promise<void> {
    await this.initializeComponent();
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
    this.categorySubscription?.unsubscribe();
    this.routerEventsSubscription?.unsubscribe();
    this.closeLoader();
  }

  private async initializeComponent(): Promise<void> {
    // Handle initial filter data if present
    if (
      this.searchService.getFilterDataLength() > 0 || 
      this.searchService.getCurrentPage() > 1 || 
      this.searchService.getSortData()
    ) {
      //console.log("entered");
      this.handleFilterData();
    } else {
      this.onChangeGetCatalog();
      this.getCartDetails();
      this.marketplace();
    }

    // Set up subscriptions
    this.setupSubscriptions();
  }

  private handleFilterData(): void {
    this.openLoader();
    this.allFilterData    = this.searchService.getFilterData();
    this.categoryList     = this.allFilterData.categoryList;
    this.categoryArray    = this.allFilterData.categoryArray;
    this.brandList        = this.allFilterData.brandList;
    this.brandArray       = this.allFilterData.brandArray;
    this.productNameList  = this.allFilterData.productNameList;
    this.productNameArray = this.allFilterData.productNameArray;
    this.versionList      = this.allFilterData.versionList;
    this.versionArray     = this.allFilterData.versionArray;
    this.businessObjList  = this.allFilterData.buisnessObjList;
    this.businessObjArray = this.allFilterData.businessObjArray;
    this.methodList       = this.allFilterData.methodList;
    this.methodArray      = this.allFilterData.methodArray;
    this.typeList         = this.allFilterData.typeList;
    this.typeArray        = this.allFilterData.typeArray;
    this.priceList        = this.allFilterData.priceData;
    this.priceArray       = this.allFilterData.priceArray;
    this.filterArray      = this.allFilterData.filterArray;
    this.currentPage      = this.allFilterData.currentPage;
    this.sortSelection    = this.allFilterData.sortSelection;
    this.sortBy           = this.allFilterData.sortBy;
    this.currentCategory  = this.allFilterData.currentCategory;
    this.currentCategory  = this.currentCategory == 'All' ? 'All Categories' : this.currentCategory;
    
    this.getCartDetails();
    this.marketplace();
  }

  private setupSubscriptions(): void {
    // Subscribe to search result changes
    this.searchSubscription = this.searchService.getSearchResult()
      .pipe(debounceTime(1000))
      .subscribe(value => {
        this.currentPage = 1;
        this.minRecords = 1;
        this.maxRecords = 10;
        this.searchInput = value;
        this.marketplace();
      });

    // Subscribe to selected category changes
    this.categorySubscription = this.searchService.getSelectedCategory()
      .subscribe(selectedCategory => {
        //console.log(selectedCategory);
        this.currentCategory = selectedCategory.name == 'All' ? 'All Categories' : selectedCategory.name;
        // Reset category-related arrays
        this.resetCatalogArrays();
        this.currentPage = 1;
        this.minRecords = 1;
        this.maxRecords = 10;
        if (selectedCategory.name == 'All') {
          this.onChangeGetCatalog();
          this.marketplace();
        } else {
          // Iterate through category list to update selection
          this.categoryList.forEach(val => {
            val.IsChecked = false;
            if (val.id == selectedCategory.id) val.IsChecked = !val.IsChecked;
          });
          this.category(selectedCategory.id, selectedCategory.category, selectedCategory.event);
        }
      });

    // Subscribe to router events
    this.routerEventsSubscription = this.router.events
      .subscribe(async (event) => {
        if (event instanceof NavigationStart) {
          // Handle navigation start event
          this.handleNavigationStart(event);
        }
      });
  }

  private handleNavigationStart(event: NavigationStart): void {
    const currentRoute = event.url;
    const moduleRoutes = ['/baseapp/marketplace', '/baseapp/marketplace/details'];
    if (moduleRoutes.some(route => currentRoute.includes(route))) {
      // Set filter data if route matches module routes
      this.setFilterData();
    } else {
      // Reset data if route doesn't match module routes
      this.resetData();
    }
  }

  private setFilterData(): void {
    this.filterData = {
      categoryList     : this.categoryList,
      categoryArray    : this.categoryArray,
      brandList        : this.brandList,
      brandArray       : this.brandArray,
      productNameList  : this.productNameList,
      productNameArray : this.productNameArray,
      versionList      : this.versionList,
      versionArray     : this.versionArray,
      buisnessObjList  : this.businessObjList,
      businessObjArray : this.businessObjArray,
      methodList       : this.methodList,
      methodArray      : this.methodArray,
      typeList         : this.typeList,
      typeArray        : this.typeArray,
      priceData        : this.priceList,
      priceArray       : this.priceArray,
      filterArray      : this.filterArray,
      currentPage      : this.currentPage,
      sortSelection    : this.sortSelection,
      sortBy           : this.sortBy,
      currentCategory  : this.currentCategory
    };
    // Set filter data in search service
    this.searchService.setFilterData(this.filterData);
  }

  private resetData(): void {
    this.openLoader();
    this.resetAll();
    this.searchService.resetFilterData();
    this.closeLoader();
  }

  private resetCatalogArrays(): void {
    this.categoryArray         = [];
    this.brandArray       = [];
    this.productNameArray = [];
    this.businessObjArray = [];
    this.versionArray     = [];
    this.methodArray      = [];
    this.typeArray        = [];
    this.priceArray       = [];
    this.filterArray      = [];
  }

  openBottomSheet(): void {
    const config: MatBottomSheetConfig = {
      data: {
        categoryList     : this.categoryList,
        categoryArray    : this.categoryArray,
        brandList        : this.brandList,
        brandArray       : this.brandArray,
        productNameList  : this.productNameList,
        productNameArray : this.productNameArray,
        versionList      : this.versionList,
        versionArray     : this.versionArray,
        buisnessObjList  : this.businessObjList,
        businessObjArray : this.businessObjArray,
        methodList       : this.methodList,
        methodArray      : this.methodArray,
        typeList         : this.typeList,
        typeArray        : this.typeArray,
        priceList        : this.priceList,
        priceArray       : this.priceArray,
        filterArray      : this.filterArray
      }
    };
    this.bottomSheetRef = this._bottomSheet.open(MarketplaceFilterComponent, config);

    this.bottomSheetRef.afterDismissed().subscribe(data => {
      this.categoryList     = data.data.categoryList;
      this.categoryArray    = data.data.categoryArray;
      this.brandList        = data.data.brandList;
      this.brandArray       = data.data.brandArray;
      this.productNameList  = data.data.productNameList;
      this.productNameArray = data.data.productNameArray;
      this.versionList      = data.data.versionList;
      this.versionArray     = data.data.versionArray;
      this.businessObjList  = data.data.buisnessObjList;
      this.businessObjArray = data.data.businessObjArray;
      this.methodList       = data.data.methodData;
      this.methodArray      = data.data.methodArray;
      this.typeList         = data.data.typeList;
      this.typeArray        = data.data.typeArray;
      this.priceList        = data.data.priceList;
      this.priceArray       = data.data.priceArray;
      this.filterArray      = data.data.filterArray;
      this.defaultCategory  = this.categoryList.filter(res=>res.IsChecked).map(ele=>ele.name);
      this.sendDefaultCategory();
      this.marketplace();
    });
  }

  sendDefaultCategory() {
    this.searchService.changeDefaultCategory(this.defaultCategory);
  }

  toggleFilterDisplay() {
    this.filterCount = (this.filterCount === 4) ? this.filterArray.length : 4;
  }

  loadMoreProductNames() {
    //console.log(this.catalogFilterData);
    this.productShow = !this.productShow;
    if(this.productNameCount != this.productNameList.length) {
      this.productNameList = [
        ...this.productNameList.slice(0, this.initialProductNameCount),
        ...this.catalogFilterData.data.products.slice(this.initialProductNameCount).map((product) => ({
          ...product,
          IsChecked: false,
          Category: "ProductName",
          name: product.name.trim().replace(/ +/g, ' ').split('_').join(' '),
        }))
      ];
    }  
  }

  loadMoreBusinessObjects() {
    this.objectShow = !this.objectShow;
    if(this.businessObjCount != this.businessObjList.length) {
      this.businessObjList = [
        ...this.businessObjList.slice(0, this.initialBusinessObjCount),
        ...this.catalogFilterData.data.busobjs.slice(this.initialBusinessObjCount).map((business) => ({
          ...business,
          IsChecked: false,
          Category: "BusinessObj"
        }))
      ];
    }  
  }

  handleFilterChange(val, catalog, arr, event) {
    this.currentPage = 1;
    this.minRecords = 1;
    this.maxRecords = 10;

    if (event.checked === true || event.isTrusted === true) {
      arr.push(val);
      this.filterArray.push(catalog);
    } else {
      const index = arr.indexOf(val);
      if (index !== -1) {
        arr.splice(index, 1);
      }
      const pos = this.filterArray.map(e => e.name).indexOf(catalog.name);
      if (pos !== -1) {
        this.filterArray.splice(pos, 1);
      }
    }
    this.onChangeGetCatalog(catalog.Category);
    this.marketplace();
  }

  category(val, catalog, event) {
    this.handleFilterChange(val, catalog, this.categoryArray, event);
  }

  brand(val, catalog, event) {
    this.handleFilterChange(val, catalog, this.brandArray, event);
  }

  productnames(val, catalog, event) {
    this.handleFilterChange(val, catalog, this.productNameArray, event);
  }

  version(val, catalog, event) {
    this.handleFilterChange(val, catalog, this.versionArray, event);
  }

  businessobj(val, catalog, event) {
    this.handleFilterChange(val, catalog, this.businessObjArray, event);
  }

  price(val, catalog, event) {
    this.handleFilterChange(val, catalog, this.priceArray, event);
  }

  type(val, catalog, event) {
    this.handleFilterChange(val, catalog, this.typeArray, event);
  }

  method(val, catalog, event) {
    this.handleFilterChange(val, catalog, this.methodArray, event);
  }

  clearFilter(val, name, filter, i) {
    this.currentPage = 1;
    this.minRecords = 1;
    this.maxRecords = 10;

    const pos = this.filterArray.map(e => e.name).indexOf(val);
    if (pos !== -1) {
      this.filterArray.splice(pos, 1);
    }

    const clearIsCheckedStatus = (list, arr, key) => {
      for (let item of list) {
        if (item.name === val) {
          item.IsChecked = false;
          break;
        }
      }

      const index = arr.indexOf(filter[key]);
      if (index !== -1) {
        arr.splice(index, 1);
      }
    };

    if (filter.Category === "Category") {
      //console.log("entered");
      clearIsCheckedStatus(this.categoryList, this.categoryArray, 'id');
      this.currentCategory = "All Categories";
      this.defaultCategory = this.categoryList.filter(res => res.IsChecked).map(ele => ele.name);

      if (this.defaultCategory.length === 0) {
        for (let c of this.categoryList) {
          if (c.name === "All") {
            c.IsChecked = true;
          }
        }
        this.defaultCategory = "All";
      }

      this.sendDefaultCategory();
      this.brandArray = [];
      this.productNameArray = [];
      this.businessObjArray = [];
      this.methodArray = [];
      this.versionArray = [];
      this.typeArray = [];
      this.priceArray = [];
      this.filterArray = [];
    } else if (filter.Category === "Brand") {
      clearIsCheckedStatus(this.brandList, this.brandArray, 'id');
    } else if (filter.Category === "ProductName") {
      clearIsCheckedStatus(this.productNameList, this.productNameArray, 'name');
    } else if (filter.Category === "Version") {
      clearIsCheckedStatus(this.versionList, this.versionArray, 'name');
    } else if (filter.Category === "BusinessObj") {
      clearIsCheckedStatus(this.businessObjList, this.businessObjArray, 'name');
    } else if (filter.Category === "Method") {
      clearIsCheckedStatus(this.methodList, this.methodArray, 'id');
    } else if (filter.Category === "Type") {
      clearIsCheckedStatus(this.typeList, this.typeArray, 'id');
    } else if (filter.Category === "Price") {
      clearIsCheckedStatus(this.priceList, this.priceArray, 'id');
    }

    this.onChangeGetCatalog();
    this.marketplace();
  }

  resetAll() {
    this.catalogDataLoaded = false;
    this.categoryArray     = [];
    this.brandArray        = [];
    this.productNameArray  = [];
    this.versionArray      = [];
    this.businessObjArray  = [];
    this.methodArray       = [];
    this.typeArray         = [];
    this.priceArray        = [];
    this.filterArray       = [];
    this.currentPage       = 1;
    this.sortSelection     = this.sortCatalog[0]['label'];
    this.sortBy            = this.sortCatalog[0]['id'];
    this.currentCategory   = "All Categories";
    this.brandShow         = false;
    this.productShow       = false;
    this.objectShow        = false;
    this.filterShow        = false;
    this.versionShow       = false;
  }

  clearAll() {
    this.resetAll();
    this.onChangeGetCatalog();
    this.marketplace();
  }

  onChangeGetCatalog(catalogType?: string[]): void {
    this.openLoader();
    let payload = {};

    const updateIsCheckedStatus = (list: any, dataToUpdate: any, key: any) => {
      list.forEach(item => {
          if (dataToUpdate.includes(item[key])) {
              item.IsChecked = true;
          }
      });
    };

    if (this.categoryArray && this.categoryArray.length > 0) {
      payload["category_id"] = this.categoryArray;
    }

    if (this.brandArray && this.brandArray.length > 0) {
      payload["brand_ids"] = this.brandArray;
    }

    if (this.productNameArray && this.productNameArray.length > 0) {
      payload["product_names"] = this.productNameArray;
    }

    if (this.businessObjArray && this.businessObjArray.length > 0) {
      payload["busobjs"] = this.businessObjArray;
    }

    if (this.methodArray && this.methodArray.length > 0) {
      payload["methods"] = this.methodArray;
    }

    if (this.typeArray && this.typeArray.length > 0) {
      payload["types"] = this.typeArray;
    }

    if (this.priceArray && this.priceArray.length > 0) {
      payload["prices"] = this.priceArray;
    }

    const catalogList = {
      Brand: 'brands',
      ProductName: 'products',
      BusinessObj: 'busobjs',
      Method: 'methods',
      Type: 'types',
      Price: 'prices',
    };
  
    const catalogListKeys = Object.keys(catalogList);
                                                                                                                                                                                                                                                                                                                                                                                                                                                          
    this.getStorage().then((res) => {
      this.backendService
        .PostAPICall('getCatalogByCategoryId', payload, res.token)
        .subscribe((data) => {
          this.catalogFilterData = data;
          if (!catalogType && !this.filterArray.some(item => item.Category)) {
            this.categoryList = data.data.categories.map(item => ({
              ...item,
              IsChecked: false,
              Category: 'Category',
            }));
            this.categoryList.unshift({ id: 0, name: "All", IsChecked: true, Category: "Category" });
            this.searchService.sendCategory(this.categoryList);
          }

          catalogListKeys.forEach(key => {
            if (catalogType && catalogType.includes(key)) {
              return;
            }
            
            const list = data.data[catalogList[key]];
            const countKey = `${key.charAt(0).toLowerCase() + key.slice(1)}Count`;
            this[countKey] = list.length;
  
            if (key === 'ProductName' || key === 'BusinessObj') {
              this[`${key.charAt(0).toLowerCase() + key.slice(1)}List`] = list.slice(0, this['initial' + key + 'Count']).map(item => ({
                ...item,
                IsChecked: false,
                Category: key,
                ...(key === 'ProductName' ? { name: item.name.trim().replace(/ +/g, ' ').split('_').join(' ') } : {}),
              }));
            } else {
              this[`${key.charAt(0).toLowerCase() + key.slice(1)}List`] = list.map(item => ({
                ...item,
                IsChecked: false,
                Category: key,
              }));
            }
          });
  
          catalogListKeys.forEach(key => {
            const comparisonField = key === 'ProductName' || key === 'BusinessObj' ? 'name' : 'id';
            updateIsCheckedStatus(this[`${key.charAt(0).toLowerCase() + key.slice(1)}List`], this[(key.charAt(0).toLowerCase() + key.slice(1)) + 'Array'], comparisonField);
          });
  
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
        });
    });
  }

  marketplace() {
    this.getStorage().then((storage) => {
      let payload = {
        user_id: storage.userId,
        category: this.categoryArray,
        brand: this.brandArray,
        type: this.typeArray,
        price: this.priceArray,
        method: this.methodArray,
        min: this.currentPage,
        max: this.page_max,
        product_name: this.productNameArray,
        business_obj: this.businessObjArray,
        sort: this.sortBy,
        q: this.searchInput
      };
      this.backendService
        .PostAPICall('marketplace', payload, storage.token)
        .subscribe(
          (data) => {
            this.catalogData = data.records;
            this.total_records = data.total_count;
            this.totalPages = Math.ceil(this.total_records / this.page_max);
            this.catalogDataLoaded = true;
            this.content.scrollToPoint(0, 0, 300);
            this.closeLoader();
          },
          (error) => {
            //console.log(error);
            this.catalogData = [];
            this.catalogDataLoaded = true;
            this.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }

  getCartDetails() {
    this.getStorage().then((storage) => {
      let payload = {
        user_id: storage.userId
      };
      this.backendService
        .PostAPICall('cartDetails', payload, storage.token)
        .subscribe(
          (data) => {
            this.cartData = data;
            this.searchService.sendCartCount(this.cartData.length);
          },
          (error) => {
            //console.log(error);
            this.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }

  catalogDetails(id) {
    this.router.navigate(['baseapp/marketplace/details/', id]);
  }

  sortBySelection(val) {
    this.sortBy = val.id;
    this.sortSelection = val.label;
    this.marketplace();
  }

  async getStorage() {
    let data = {
      token: await this.storage.get('token'),
      userId: await this.storage.get('id'),
      showDialog: await this.storage.get('showDialog'),
    };
    return data;
  }

  getRecordsCount(page: any) {
    this.minRecords = ((page - 1) * 10) + 1;
    if(this.totalPages == page) {
      this.maxRecords = this.total_records;
    }
    else {
      this.maxRecords = page * 10;
    }

  }

  onGoTo(page: any): void {
    this.openLoader();
    this.currentPage = page;
    this.getRecordsCount(this.currentPage);
    this.marketplace();
  }

  onNext(page: any): void {
    this.openLoader();
    this.currentPage = page + 1;
    this.getRecordsCount(this.currentPage);
    this.marketplace();
  }

  onPrevious(page: any): void {
    this.openLoader();
    this.currentPage = page - 1;
    this.getRecordsCount(this.currentPage);
    this.marketplace();
  }

  scrollToTop(el) {
    el.scrollTop = 0;
  }

  async openLoader() {
    this.loader = await this.loadingController.create({
        message: 'Please wait...',
    });

    await this.loader.present();
    
    // Set a timeout to automatically dismiss the loader after 5 seconds
    setTimeout(async () => {
        await this.closeLoader();
    }, 5000);
  }

  async closeLoader() {
    if (this.loader) {
      await this.loader.dismiss(); 
    } else {
      //console.log('No loader to dismiss.');
    }
  }
  
}